import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  signatureContainer: {
    border: "solid 1px #E4E7EC",
    borderRadius: 4,
    marginBottom: "2px",
  },
  buttonSave: {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: 14,
    lineHeight: "120%",
    color: "#308CDB",
    justifyContent: "flex-start",
  },
  buttonClear: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "120%",
  },
  signatureName: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: 14,
    color: "#465869",
    lineHeight: "100%",
  },
}));

export default styles;
